// userPremiumUtils.js

export const isUserPaid = () => {
  const userPremium = JSON.parse(localStorage.getItem("userPremimium")) || [];
  const clubDetails = JSON.parse(localStorage.getItem("club_details")) || {};
  const user = JSON.parse(localStorage.getItem("user")) || {};

  const now = new Date();

  const isValidForOneYear = (createdAt) => {
    if (!createdAt) return false;
    const expiryDate = new Date(createdAt);
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    return now <= expiryDate;
  };

  for (const entry of userPremium) {
    if (entry.user_id !== user.id) continue; // skip others' subscriptions

    // Case 1: Global Premium (sub_type === 2)
    if (entry.sub_type === 2 && isValidForOneYear(entry.created_at)) {
      return 1;
    }

    // Case 2: Club-based subscription
    if (entry.club === clubDetails.id) {
      if (entry.sub_type === 1) return 1; // valid, no expiry
      return 0; // sub_type === 2 but expired, or other invalid
    }
  }

  return 0; // no valid subscription
};
export const isPaidEntryFee = () => {
  const userEntryFee = JSON.parse(localStorage.getItem("userEntryFee")) || [];
  const clubDetails = JSON.parse(localStorage.getItem("club_details")) || {};
  const user = JSON.parse(localStorage.getItem("user")) || {};

  for (const entry of userEntryFee) {
    if (entry.user_id === user.id && entry.game_id === clubDetails.id) {
      return 1; // valid subscription found
    }
  }

  return 0; // no valid subscription
};
export const getClubInfo = () => {
  const clubDetails = JSON.parse(localStorage.getItem("club_details"));
  return clubDetails;
};
